import { render } from "./searchClass.vue?vue&type=template&id=528e0ee5"
import script from "./searchClass.vue?vue&type=script&lang=js"
export * from "./searchClass.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__